import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { Quiz } from '../types';

let quizzesCache: Quiz[] = [];
let lastFetch = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minuti

export async function getQuizzes(): Promise<Quiz[]> {
  try {
    const now = Date.now();
    if (quizzesCache.length > 0 && (now - lastFetch) < CACHE_DURATION) {
      return quizzesCache;
    }

    const quizzesCol = collection(db, 'quizzes');
    const snapshot = await getDocs(quizzesCol);
    const quizzes: Quiz[] = snapshot.docs.map((quizDoc) => {
      const data = quizDoc.data() as any;
      return {
        id: quizDoc.id,
        title: data.title || 'Quiz senza titolo',
        description: data.description || '',
        url: data.url || '',
        image: data.image || '',
        category: data.category || '',
        tags: data.tags || [],
        createdAt: data.createdAt?.toDate?.() || undefined,
        updatedAt: data.updatedAt?.toDate?.() || undefined,
      };
    });

    quizzesCache = quizzes;
    lastFetch = now;
    return quizzes;
  } catch (error) {
    console.error('Errore nel recupero dei quiz:', error);
    return [];
  }
}

export async function createQuiz(quiz: Omit<Quiz, 'id' | 'createdAt' | 'updatedAt'>): Promise<string> {
  const quizzesCol = collection(db, 'quizzes');
  const docRef = await addDoc(quizzesCol, {
    ...quiz,
    createdAt: new Date(),
    updatedAt: new Date(),
  });
  invalidateQuizzesCache();
  return docRef.id;
}

export async function updateQuiz(quizId: string, quiz: Partial<Omit<Quiz, 'id' | 'createdAt'>>): Promise<void> {
  const quizRef = doc(db, 'quizzes', quizId);
  await updateDoc(quizRef, {
    ...quiz,
    updatedAt: new Date(),
  });
  invalidateQuizzesCache();
}

export async function deleteQuiz(quizId: string): Promise<void> {
  const quizRef = doc(db, 'quizzes', quizId);
  await deleteDoc(quizRef);
  invalidateQuizzesCache();
}

export function invalidateQuizzesCache() {
  quizzesCache = [];
  lastFetch = 0;
}
